/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_Bookings_Revenue_NotificationInputs */

const en_admin_dashboard_bookings_revenue_notification = /** @type {(inputs: Admin_Dashboard_Bookings_Revenue_NotificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estimate. Not yet invoiced.`)
};

const de_admin_dashboard_bookings_revenue_notification = /** @type {(inputs: Admin_Dashboard_Bookings_Revenue_NotificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vorläufiger Wert. Noch nicht abgerechnet.`)
};

const es_admin_dashboard_bookings_revenue_notification = /** @type {(inputs: Admin_Dashboard_Bookings_Revenue_NotificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estimado. No facturado todavía.`)
};

const fr_admin_dashboard_bookings_revenue_notification = /** @type {(inputs: Admin_Dashboard_Bookings_Revenue_NotificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estimation. Pas encore facturé.`)
};

const nl_admin_dashboard_bookings_revenue_notification = /** @type {(inputs: Admin_Dashboard_Bookings_Revenue_NotificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schatting. Nog niet gefactureerd.`)
};

const it_admin_dashboard_bookings_revenue_notification = /** @type {(inputs: Admin_Dashboard_Bookings_Revenue_NotificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stima. Non ancora fatturato.`)
};

const pt_br2_admin_dashboard_bookings_revenue_notification = /** @type {(inputs: Admin_Dashboard_Bookings_Revenue_NotificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estimativa. Ainda não faturado.`)
};

const pl_admin_dashboard_bookings_revenue_notification = /** @type {(inputs: Admin_Dashboard_Bookings_Revenue_NotificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przychód szacunkowy. Jeszcze nie zafakturowane.`)
};

const hu_admin_dashboard_bookings_revenue_notification = /** @type {(inputs: Admin_Dashboard_Bookings_Revenue_NotificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Becslés, még nincs kiszámlázva.`)
};

const ro_admin_dashboard_bookings_revenue_notification = /** @type {(inputs: Admin_Dashboard_Bookings_Revenue_NotificationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estimare. Inca nefacturat.`)
};

/**
* | output |
* | --- |
* | "Estimate. Not yet invoiced." |
*
* @param {Admin_Dashboard_Bookings_Revenue_NotificationInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_bookings_revenue_notification = /** @type {((inputs?: Admin_Dashboard_Bookings_Revenue_NotificationInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_Bookings_Revenue_NotificationInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_bookings_revenue_notification(inputs)
	if (locale === "de") return de_admin_dashboard_bookings_revenue_notification(inputs)
	if (locale === "es") return es_admin_dashboard_bookings_revenue_notification(inputs)
	if (locale === "fr") return fr_admin_dashboard_bookings_revenue_notification(inputs)
	if (locale === "nl") return nl_admin_dashboard_bookings_revenue_notification(inputs)
	if (locale === "it") return it_admin_dashboard_bookings_revenue_notification(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_bookings_revenue_notification(inputs)
	if (locale === "pl") return pl_admin_dashboard_bookings_revenue_notification(inputs)
	if (locale === "hu") return hu_admin_dashboard_bookings_revenue_notification(inputs)
	return ro_admin_dashboard_bookings_revenue_notification(inputs)
});
export { admin_dashboard_bookings_revenue_notification as "admin.dashboard.bookings_revenue_notification" }